export default "__VITE_ASSET__DSbHXPO7__"